// extracted by mini-css-extract-plugin
export default {"btn":"LeftArrow_btn__935hs","btnLeft":"LeftArrow_btnLeft__qckEv"};